/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterN = createReactComponent("outline", "letter-n", "IconLetterN", [["path", { "d": "M7 20v-16l10 16v-16", "key": "svg-0" }]]);

export { IconLetterN as default };
//# sourceMappingURL=IconLetterN.mjs.map
